import { request } from './request';
import { apiOrigin } from './config';

// 手机号登录
export const ApiLoginByAccount = data => {
    const url = `${apiOrigin}/api/member/auth/xdSaaSbd/login/pwd`;
    return request({
        url,
        method: 'POST',
        data
    });
};

// 短信验证码登录
export const ApiLoginByPhone = data => {
    return request({
        url: `${apiOrigin}/api/member/auth/xdSaaSbd/login/smsCode`,
        method: 'POST',
        data
    });
};

/**
 * 带有图形验证码的手机号登录
 * @param { Object } data: { userName: '', password: '' , code: '', uuid: ''}
 */
export const ApiLoginByGraphCodeAccount = data => {
    const url = `${apiOrigin}/api/member/auth/xdSaaSbd/login/pwdCode`;
    return request({
        url,
        method: 'POST',
        data
    });
};

/**
 * 手机号登录/注册/修改手机号/修改密码时获取短信验证码
 * @param {Object} data: { phone: '', code: '图形验证码', uuid: 图形验证码对应的uuid }
 * @param {String} type 登录/注册/修改时获取短信验证码不一样，通过type区分，默认就是登录模式， 注册时需要传1
 * */
export const ApiGetSmsCode = (data, type) => {
    let url = '';
    // 注册登录时，手机号必填，修改时可以不填手机号
    if (type === 'register') {
        data = {
            ...data,
            type: '1'
        };
        url = '/api/saas/backend/tenantUser/sendSms';
    } else if (type === 'login') {
        url = '/api/member/auth/common/sendSmsV2';
    } else if (type === 'profile') {
        data = {
            ...data,
            type: '1'
        };
        url = '/api/saas/backend/sysTenantUser/sendSms';
    }
    return request({
        url: `${apiOrigin}${url}`,
        method: 'POST',
        data
    });
};

/**
 * 登出
 *
 * @return {Promise} Any
 */
export const signOutHandler = () => {
    const url = `${apiOrigin}/api/member/auth/common/logout`;
    return request({
        url,
        method: 'POST',
        signout: true
    });
};

/**
 * 获取图形验证码
 * @param {String} uuid
 * @param {String} type 登录/修改手机号/修改密码/和注册时的图形验证码不一样，通过type区分，默认就是登录/修改手机号/修改密码/模式
 */
export const ApiGetGraphCode = (uuid, type) => {
    let url = '';
    if (type === 'login') {
        url = `/api/member/auth/common/getValidationCode/${uuid}`;
    } else {
        url = `/api/saas/backend/tenantUser/getValidationCode/${uuid}`;
    }
    return request({
        url: type === 'register' ? `${apiOrigin}${url}` : `${apiOrigin}${url}`,
        method: 'get',
        responseType: 'arraybuffer'
    });
};

// 注册
export const ApiRegister = data => {
    return request({
        url: `${apiOrigin}/api/saas/backend/tenantUser/tenantRegister`,
        method: 'POST',
        data
    });
};

// 获取侧边栏菜单
export const ApiSidebarMenu = () => {
    return request({
        url: `${apiOrigin}/api/saas/backend/tenantUser/versionMenu/queryTenantMenuTree`,
        method: 'post'
    });
};

// 查询菜单版本列表
export const ApiGetVersionList = () => {
    return request({
        url: `${apiOrigin}/api/saas/backend/app/queryAllVersionList`,
        method: 'get'
    });
};

/**
 * 提交选择的版本
 * @param {String}  versionId: 版本ID
 */

export const ApiUpdateVersion = versionId => {
    return request({
        url: `${apiOrigin}/api/saas/backend/app/updateTenantVersion?versionId=${versionId}`,
        method: 'get'
    });
};

// 查询用户是否选择了版本
export const ApiGetSelectedVersion = () => {
    return request({
        url: `${apiOrigin}/api/saas/backend/app/getTenantInfo`,
        method: 'get'
    });
};

//密钥登录
export const ApiLoginBySecret = data => {
    return request({
        url: `${apiOrigin}/api/member/auth/xdSaaSbd/login/secret?secret=${data.secret}`,
        method: 'post',
        data
    });
};
